var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedChangePasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:password"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3229 14.1663C10.7649 14.1663 11.1889 13.9907 11.5014 13.6782C11.814 13.3656 11.9896 12.9417 11.9896 12.4997C11.9896 12.0576 11.814 11.6337 11.5014 11.3212C11.1889 11.0086 10.7649 10.833 10.3229 10.833C9.88089 10.833 9.45697 11.0086 9.14441 11.3212C8.83184 11.6337 8.65625 12.0576 8.65625 12.4997C8.65625 12.9417 8.83184 13.3656 9.14441 13.6782C9.45697 13.9907 9.88089 14.1663 10.3229 14.1663ZM15.3229 6.66634C15.7649 6.66634 16.1889 6.84194 16.5014 7.1545C16.814 7.46706 16.9896 7.89098 16.9896 8.33301V16.6663C16.9896 17.1084 16.814 17.5323 16.5014 17.8449C16.1889 18.1574 15.7649 18.333 15.3229 18.333H5.32292C4.88089 18.333 4.45697 18.1574 4.14441 17.8449C3.83184 17.5323 3.65625 17.1084 3.65625 16.6663V8.33301C3.65625 7.89098 3.83184 7.46706 4.14441 7.1545C4.45697 6.84194 4.88089 6.66634 5.32292 6.66634H6.15625V4.99967C6.15625 3.89461 6.59524 2.8348 7.37664 2.0534C8.15804 1.27199 9.21785 0.833008 10.3229 0.833008C10.8701 0.833008 11.4119 0.940782 11.9174 1.15018C12.423 1.35957 12.8823 1.66649 13.2692 2.0534C13.6561 2.44031 13.963 2.89964 14.1724 3.40516C14.3818 3.91068 14.4896 4.4525 14.4896 4.99967V6.66634H15.3229ZM10.3229 2.49967C9.65988 2.49967 9.02399 2.76307 8.55515 3.23191C8.08631 3.70075 7.82292 4.33663 7.82292 4.99967V6.66634H12.8229V4.99967C12.8229 4.33663 12.5595 3.70075 12.0907 3.23191C11.6218 2.76307 10.986 2.49967 10.3229 2.49967Z",
    fill: "url(#paint0_linear_704_199)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_704_199",
    x1: 10.3229,
    y1: 0.833008,
    x2: 10.3229,
    y2: 18.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedChangePasswordIcon);
export default __webpack_public_path__ + "static/media/selectedChangePasswordIcon.13f73c465274bbcc6675ba388e8cd00b.svg";
export { ForwardRef as ReactComponent };